import { Component, DestroyRef, inject, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { FolderResource } from '@shared/modules/folders/folders.types';
import { AccountFoldersService } from 'app/modules/folders/folders.service';

@Component({
  selector: 'create-folder',
  templateUrl: './create-folder.component.html',
  styleUrls: ['./create-folder.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CreateFolderComponent implements OnInit {
  createFolderForm: UntypedFormGroup;
  folderResource: FolderResource;

  private readonly destroyRef = inject(DestroyRef);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public readonly matDialogRef: MatDialogRef<CreateFolderComponent>,
    private readonly _formBuilder: UntypedFormBuilder,
    private readonly accountFoldersService: AccountFoldersService,
  ) {}

  ngOnInit(): void {
    this.createFolderForm = this._formBuilder.group({
      id: [''],
      name: ['', [Validators.required]],
    });

    if (this.data.folderResource) {
      this.folderResource = this.data.folderResource;
      this.createFolderForm.patchValue(this.folderResource);
    }
  }

  discard(): void {
    this.matDialogRef.close();
  }

  save(): void {
    if (this.createFolderForm.invalid) return;

    let folder = this.createFolderForm.value;
    folder.parent_id = this.data.folderId;

    if (this.folderResource) {
      this.accountFoldersService
        .updateFolder(folder)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((result) => {
          this.matDialogRef.close(result);
        });
    } else {
      this.accountFoldersService
        .createFolder(folder)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((result) => {
          this.matDialogRef.close(result);
        });
    }
  }
}
